var config = {
    requestBaseUrl: "https://api.chongbaidu.com/"
};

export default config;
